﻿import { Component, OnInit } from '@angular/core';


@Component({ templateUrl: 'gracias.component.html' })
export class PublicGraciasComponent implements OnInit {


    constructor() {
    }


    ngOnInit() {
    }

   

}
